define("shared/components/shared/post/secondary/caption-writer/info-modal", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{@closeModal}} @focusTrap={{true}} data-test-id="caption-writer-info-modal" as |modal|>
    <modal.card @portrait={{true}} class="has--footer qa--caption_writer_info_modal">
      <modal.card-header @title={{t "caption_writer.title"}} />
  
      <modal.card-body class="u--p__t__0">
        <section class="u--m__b__md">
          <p>
            {{t "caption_writer.info_modal.instructions" htmlSafe=true}}
          </p>
          <Shared::Link
            @class="u--text--hl"
            @href="https://help.later.com/hc/articles/12252569781015"
            @text={{t "shared_phrases.learn_more"}}
            @type="unstyled"
          />
        </section>
  
        <section>
          <p class="u--m__b__md">
            {{t "caption_writer.info_modal.disclaimer" htmlSafe=true}}
          </p>
        </section>
  
        <section>
          <p class="u--m__b__md">
            {{t "caption_writer.info_modal.about_credits" htmlSafe=true}}
          </p>
          <Shared::Post::Secondary::CaptionWriter::UpgradeButton
            @onSeamlessCheckoutSuccess={{@onSeamlessCheckoutSuccess}}
            @showUpgradeNote={{true}}
            @text={{t "caption_writer.info_modal.need_more_credits"}}
            @variant="actionLink"
            class="u--text--success qa--info-modal_upgrade_plan_link"
          />
        </section>
      </modal.card-body>
  
      <modal.card-footer>
        <Shared::Ui::Button
          @additional="block"
          @onClick={{@closeModal}}
          @text={{t "shared_words.close"}}
          @variant="outline"
          class="qa--aiCaptions_info_modal_close_btn"
          data-test-id="caption-writer-info-modal-close-button"
        />
      </modal.card-footer>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "9+ycljRe",
    "block": "[[[8,[39,0],[[24,\"data-test-id\",\"caption-writer-info-modal\"]],[[\"@close\",\"@focusTrap\"],[[30,1],true]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],[[24,0,\"has--footer qa--caption_writer_info_modal\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,2,[\"card-header\"]],null,[[\"@title\"],[[28,[37,1],[\"caption_writer.title\"],null]]],null],[1,\"\\n\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"section\"],[14,0,\"u--m__b__md\"],[12],[1,\"\\n        \"],[10,2],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"caption_writer.info_modal.instructions\"],[[\"htmlSafe\"],[true]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,2],null,[[\"@class\",\"@href\",\"@text\",\"@type\"],[\"u--text--hl\",\"https://help.later.com/hc/articles/12252569781015\",[28,[37,1],[\"shared_phrases.learn_more\"],null],\"unstyled\"]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,\"section\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__md\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"caption_writer.info_modal.disclaimer\"],[[\"htmlSafe\"],[true]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[10,\"section\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__md\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"caption_writer.info_modal.about_credits\"],[[\"htmlSafe\"],[true]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,3],[[24,0,\"u--text--success qa--info-modal_upgrade_plan_link\"]],[[\"@onSeamlessCheckoutSuccess\",\"@showUpgradeNote\",\"@text\",\"@variant\"],[[30,3],true,[28,[37,1],[\"caption_writer.info_modal.need_more_credits\"],null],\"actionLink\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,4],[[24,0,\"qa--aiCaptions_info_modal_close_btn\"],[24,\"data-test-id\",\"caption-writer-info-modal-close-button\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,1],[28,[37,1],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@closeModal\",\"modal\",\"@onSeamlessCheckoutSuccess\"],false,[\"shared/modal\",\"t\",\"shared/link\",\"shared/post/secondary/caption-writer/upgrade-button\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/info-modal.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});